const backendLink = (endpoint, key = null) => {

  // if (process.env.NODE_ENV !== "production") {
  //   return `http://localhost/api/calculadora_vida/${endpoint}${key ? "/" + key : ""
  //     }/`
  // }

  return `/costo-de-vida/api/calculadora_vida/${endpoint}${key ? "/" + key : ""}/`
}

const api = {
  getCalculateRubros: async (rubros, paisId, ciudadId) => {
    try {
      const response = await fetch(
        backendLink("obtenerCalculoRubroCiudadNew.php"),
        {
          method: "POST",
          body: JSON.stringify({ rubros, paisId, ciudadId }),
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      const json = await response.json()
      return json
    } catch (e) {
      return false
    }
  },
  getRubros: async () => {
    try {
      const response = await fetch(backendLink("obtenerRubros.php"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      })
      const json = await response.json()
      return json
    } catch (e) {
      return false
    }
  },
}

export default api
